<template>
  <section>
    <gs-header title="Quản lý bài viết">
      <router-link :to="{ name: 'create-blog' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="blogTable" :table-name="blogTable" data-source="blogs" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-select v-model="filters.category_id" filterable placeholder="Chọn danh mục cha" @change="filter"
                class="width-100">
                <el-option label="Chọn danh mục cha" :value="-1">
                </el-option>
                <el-option v-for="(category, index) in categories" :key="index" :label="category.name"
                  :value="category.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-radio-group class="status-listting margin-lg-right" v-model="filters.show_blog"
                @change="changeShowBlog" :fill="showBlogBg[filters.show_blog]">
                <el-radio-button :label="1"><span :class="{ 'text-white': filters.show_blog === 1 }"
                    class="text-teal">Hiển thị ở landing</span></el-radio-button>
                <el-radio-button :label="2"><span :class="{ 'text-white': filters.show_blog === 2 }"
                    class="text-green">Hiển thị ở shop</span></el-radio-button>
                <el-radio-button :label="-1"><span :class="{ 'text-white': filters.show_blog === -1 }"
                    class="text-blue">Tất cả</span></el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[blogTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[blogTable].current_page - 1) * dataPaginations[blogTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="" width="150">
              <template slot-scope="scope">
                <img class="cursor-pointer" :src="scope.row.image_path" width="130" @click="redirect(scope.row)"
                  :alt="scope.row.title"
                  onerror="this.src='https://placeholdit.imgix.net/~text?txtsize=14&txt=150%C3%97150&w=150&h=150'">
              </template>
            </el-table-column>

            <el-table-column label="Tiêu đề">
              <template slot-scope="scope">
                <p>{{ scope.row.title }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Tóm tắt">
              <template slot-scope="scope">
                <p>{{ scope.row.teaser }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Danh mục" width="150">
              <template slot-scope="scope">
                <p v-if="scope.row.category">{{ scope.row.category.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Người viết" width="150">
              <template slot-scope="scope">
                <p v-if="scope.row.author">{{ scope.row.author.data.name }}</p>
              </template>
            </el-table-column>


            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Ẩn" class="display-inline" v-if="!scope.row.active">
                    <a @click.prevent="toggleDisable(scope.row)"
                      class="text-brown padding-all display-inline-block cursor-pointer"><i
                        class="fa  fa-eye-slash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Kích hoạt" class="display-inline" v-if="scope.row.active">
                    <a @click.prevent="toggleEnable(scope.row)"
                      class="text-green padding-all display-inline-block cursor-pointer"><i class="fa fa-eye"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Bỏ Hot" class="display-inline" v-if="scope.row.hot">
                    <a @click.prevent="disableHot(scope.row)"
                      class="text-gray padding-all display-inline-block cursor-pointer"><i class="fa fa-star-o"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Hot" class="display-inline" v-if="!scope.row.hot">
                    <a @click.prevent="enableHot(scope.row)"
                      class="text-teal padding-all display-inline-block cursor-pointer"><i class="fa fa-star"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-blog', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a @click.prevent="deleteBlog(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { deleteBlog, editBlog } from 'src/api/blogs'
import { debounce, head } from 'lodash'
import ls from 'local-storage'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'Blog',

  data() {
    return {
      blogTable: 'blogs',
      filters: {
        sort: 'created_at:-1',
        include: 'category,author',
        category_id: '',
        show_blog: -1,
        show_on_shop: -1,
        show_on_landing: -1
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      currentRegion: {},
      deleteModal: false,
      detailModal: false,
      showBlogBg: {
        1: '#008080',
        2: '#32CD32',
        '-1': ''
      }
    }
  },
  computed: {
    ...mapGetters('blog', ['blog']),
    ...mapGetters('category', ['categories'])
  },
  methods: {
    ...mapActions('blog', ['setBlog']),
    ...mapActions('category', ['getAllCategories']),
    removeFilter() {
      this.reloadGsTable(this.blogTable)
      this.filters = {
        sort: 'created_at:-1',
        include: 'category,author',
        category_id: '',
        show_on_shop: -1
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.blogTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.blogTable)
      }
    }, 300),
    deleteBlog(blog) {
      this.setBlog(blog)
      this.$confirm(`Bạn chắc chắn muốn xóa bài viết: ${blog.title} ?`, 'Xóa bài viết', {
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delBLog()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy xóa danh mục bài viết'
        })
      })
    },
    delBLog() {
      deleteBlog(this.blog.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa bài viết thành công'
          })
          this.deleteModal = false
          this.reloadGsTable(this.blogTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa bài viết thất bại'
          })
        }
      })
    },
    toggleEnable(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true })
      let dataBlog = Object.assign({}, data)
      dataBlog.active = 0
      let message = 'Hiện bài viết thành công'
      this.updateDataBlog(dataBlog, message)
    },
    toggleDisable(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true })
      let dataBlog = Object.assign({}, data)
      dataBlog.active = 1
      let message = 'Ẩn bài viết thành công'
      this.updateDataBlog(dataBlog, message)
    },
    enableHot(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true })
      let dataBlog = Object.assign({}, data)
      dataBlog.hot = 1
      let message = 'Kích hoạt Hot thành công'
      this.updateDataBlog(dataBlog, message)
    },
    disableHot(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true })
      let dataBlog = Object.assign({}, data)
      dataBlog.hot = 0
      let message = 'Bỏ Hot thành công'
      this.updateDataBlog(dataBlog, message)
    },
    updateDataBlog(data, message) {
      editBlog(data.id, data).then(response => {
        if (response.code === 200) {
          this.$store.dispatch('toggleLoadding', false, { root: true })
          this.$store.dispatch('showNotify', {
            title: 'Cập nhật thành công',
            body: message
          })
          this.reloadGsTable(this.blogTable)
        }

        if (response.code === 422) {
          this.$store.dispatch('toggleLoadding', false, { root: true })
          let er = response.data.errors
          let message = head(er)
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            body: message,
            type: 'warning'
          })
        }
      })
    },
    redirect(blog) {
      if (blog.id !== '' && blog.slug !== '') {
        window.open(process.env.CMS_URL + blog.id + '-' + blog.slug)
      }
    },
    changeShowBlog() {
      switch (this.filters.show_blog) {
        case 1:
          this.filters.show_on_landing = 1
          this.filters.show_on_shop = -1
          break
        case 2:
          this.filters.show_on_landing = -1
          this.filters.show_on_shop = 1
          break
        default:
          this.filters.show_on_landing = -1
          this.filters.show_on_shop = -1
      }
      this.filter()
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.blogTable]) {
      this.filters = ls.get('filters')[this.blogTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.blogTable)
    if (!this.categories.length) {
      this.getAllCategories({ limit: -1 })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['blogs']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Blog.vue?fd267394